export default "__VITE_ASSET__D9KjV80w__"